import { all, fork, takeEvery, put } from 'redux-saga/effects';

// constants
import { CURRENT_GROUP_CLEAR } from '../../constants/groupTypes';

// action creators
import { doneIndicator } from 'store/actions/httpActions';

// lib
import { navigateTo } from 'store/actions/navigationActions';

export function* clearCurrentGroup(action: any) {
  const { skipNavigate = false } = action.payload || {};
  const { pathname, search } = window.location;
  const TYPE = CURRENT_GROUP_CLEAR;

  try {
    yield localStorage.removeItem('group');

    if (!skipNavigate) {
      // Remove the group query param from the URL!
      //  Replace the URL with a string that does not have the group param
      const urlParams = new URLSearchParams(search);
      yield urlParams.delete('group');
      const newUrlParams = urlParams.toString() || '';

      yield put(navigateTo(`${pathname}?${newUrlParams}`, { replace: true }));
    }
  } finally {
    yield put(doneIndicator(TYPE));
  }
}

export function* watchCurrentGroupClear() {
  yield takeEvery(CURRENT_GROUP_CLEAR, clearCurrentGroup);
}

export default function* root() {
  yield all([fork(watchCurrentGroupClear)]);
}
